import { useNavigate } from "react-router-dom";

import PetpoojaLogo from "./../imgs/petpooja-small-logo.png";
import ShopifyLogo from "./../imgs/shopify-small-logo.png";

import {

    Store,
    Clock3,
    Code2,
    Zap,
    ShoppingBag,
    ChevronRight

} from "lucide-react";

export function ChooseIntegration() {

    const navigate = useNavigate();

    const integrations = [

        {

            id: "petpooja",

            name: "PetPooja POS",

            description:
                "Connect your PetPooja POS to start sending offers to your customers at checkout.",

            image: PetpoojaLogo,

            tags: [

                {

                    icon: <Store size={16} />,

                    label: "Works at in-store checkout"

                },

                {

                    icon: <Clock3 size={16} />,

                    label: "Takes 1–2 days to activate"

                },

                {

                    icon: <Code2 size={16} />,

                    label: "No coding required"

                }

            ]

        },

        {

            id: "shopify",

            name: "Shopify",

            description:
                "Install the NextGo Shopify app on your Shopify store to display partner offers on the order status (Thank You) page.",

            image: ShopifyLogo,

            tags: [

                {

                    icon: <Zap size={16} />,

                    label: "Instant setup"

                },

                {

                    icon: <ShoppingBag size={16} />,

                    label: "Show offers after checkout"

                },

                {

                    icon: <Code2 size={16} />,

                    label: "No coding required"

                }

            ]

        }

    ];

    function handleIntegrationClick(id) {

        switch (id) {

            case "petpooja":

                navigate("/setup/integrations/petpooja");

                break;

            case "shopify":

                navigate("/setup/integrations/shopify");

                break;

            default:

                break;

        }

    }

    function handleSkip() {

        navigate("/overview");

    }

    return (

        <>

            <header className="setup-header">

                <div className="setup-header-logo">

                    <img

                        src={require("./../imgs/nextgo-logo.png")}

                        alt="NextGo Logo"

                        className="setup-header-logo-icon"

                    />

                    <span className="setup-header-logo-text">

                        Next<span className="blue">Go</span>

                    </span>

                </div>

            </header>

            <main className="business-details-page">

                <div className="business-details-layout">

                    <aside className="setup-sidebar">

                        <div>

                            <span className="setup-badge">

                                Step 3 of 3

                            </span>

                            <h1>

                                Almost there

                            </h1>

                            <p>

                                Connect NextGo with the platform you use to run your business. You can always connect more integrations later.

                            </p>

                        </div>

                        <div className="setup-progress">

                            <div className="setup-step completed">

                                <div className="setup-step-number">

                                    ✓

                                </div>

                                <div>

                                    <h3>

                                        Business Details

                                    </h3>

                                    <p>

                                        Tell us about your business

                                    </p>

                                </div>

                            </div>

                            <div className="setup-step completed">

                                <div className="setup-step-number">

                                    ✓

                                </div>

                                <div>

                                    <h3>

                                        First Outlet

                                    </h3>

                                    <p>

                                        Your first outlet is ready

                                    </p>

                                </div>

                            </div>

                            <div className="setup-step active">

                                <div className="setup-step-number">

                                    3

                                </div>

                                <div>

                                    <h3>

                                        Integrations

                                    </h3>

                                    <p>

                                        Connect your software

                                    </p>

                                </div>

                            </div>

                        </div>

                        <div className="setup-tip">

                            <strong>

                                Good to know

                            </strong>

                            <p>

                                You can skip this step now and connect integrations later from your dashboard.

                            </p>

                        </div>

                    </aside>

                    <section className="business-details-card">

                        <h2>

                            Choose an integration

                        </h2>

                        <p className="setup-description">

                            Select the software you use to run your business. We'll guide you through connecting it to NextGo.

                        </p>

                        <div className="integration-section">

                            {

                                integrations.map((integration) => (

                                    <button

                                        key={integration.id}

                                        className="integration-card"

                                        onClick={() =>
                                            handleIntegrationClick(integration.id)
                                        }

                                    >

                                        <div className="integration-logo">

                                            <img

                                                src={integration.image}

                                                alt={integration.name}

                                            />

                                        </div>

                                        <div className="integration-content">

                                            <h3>

                                                {integration.name}

                                            </h3>

                                            <p>

                                                {integration.description}

                                            </p>

                                            <div className="integration-tags">

                                                {

                                                    integration.tags.map((tag) => (

                                                        <div

                                                            key={tag.label}

                                                            className="integration-tag"

                                                        >

                                                            {tag.icon}

                                                            <span>

                                                                {tag.label}

                                                            </span>

                                                        </div>

                                                    ))

                                                }

                                            </div>

                                        </div>

                                        <ChevronRight

                                            size={22}

                                            className="integration-arrow"

                                        />

                                    </button>

                                ))

                            }

                        </div>

                        <div className="setup-actions">

                            <button

                                className="secondary-button"

                                onClick={handleSkip}

                            >

                                Skip for now

                            </button>

                        </div>

                    </section>

                </div>

            </main>

        </>

    );

}